<template>
    <div class="learn-detail" ref="schoolIndex">
        <div class="back" @click="back">
            <van-icon name="arrow-left" />
        </div>
        <div class="internalCourse">
            <div class="video" @click="showVideo()">
                <img style="object-fit: fill" :src=" courseInfo.preview ? $utils.setSourcePath(courseInfo.preview) : ''"/>
                <img class="play" v-if="(courseInfo.path||'').includes('mp4')" src="@/assets/img/play.png" />
            </div>
            <!-- <template v-if="(courseInfo.path||'').includes('mp4')">
            <video :src="$utils.setSourcePath(courseInfo.path)" :poster="$utils.setSourcePath(courseInfo.preview)" controls />
            </template>
            <template v-if="(courseInfo.path||'').includes('pdf')">
            <pdf :src="$utils.setSourcePath(courseInfo.path)"></pdf>
            </template>
            <template v-if="(courseInfo.path||'').includes('jpg')">
            <van-image class="courseImg" :src="$utils.setSourcePath(courseInfo.preview)"/>
            </template> -->
            <div class="userinfo">
                <div class="image">
                    <van-image round  fit="cover" :src="$utils.setSourcePath(courseInfo.headimg,0)"/>
                </div>
                <div class="name ellipsis">{{ courseInfo.firstName }}</div>
            </div>
            <div class="title">{{ courseInfo.title }}</div>
            <div class="tagAndRate">
                <div class="tags">
                    <div>{{courseInfo.typeName}}</div>
                    <div>{{courseInfo.length}}min</div>
                    <!-- <van-tag color="#f4f5f8" text-color="#7b828f">Product Course</van-tag>
                    <van-tag color="#ffe1e1" text-color="#ad0000">3min</van-tag> -->
                </div>
                <div class="rate" v-if="courseInfo.isStar==1">
                    <div class="star">
                       <van-icon name="star" />
                    </div>
                    Rating: {{courseInfo.star}}.0
                </div>
            </div>
        </div>
        <div class="courseIntroduce">
            <div class="title">
                {{$t('business_school.course_intro')}}
            </div>
            <div class="introduce" v-html="courseInfo.introduce"></div>
        </div>
        <div class="tabbar">

            <div class="footer-button" @click="favorited">
                <img v-if="courseInfo.isFav==1" src="@/assets/img/collection2_red.png" />
                <img v-else src="@/assets/img/collection2.png" />
            </div>
            <div class="footer-button" v-if="courseInfo.isStar==1" @click="showStar=true">
                <van-icon name="edit" />
            </div>
            <van-dialog class="starDialog" v-model:show="showStar" @confirm="handlerStar" :confirmButtonText="$t('text.submit')" :cancelButtonText="$t('text.cancel')" :title="$t('text.learned')" show-cancel-button>
                <h4>{{$t('text.tap_star_to_score')}}</h4>
                <van-rate v-model="courseInfo.star" :size="25" color="#ffd21e" void-icon="star" void-color="#eee"/>
                <h4>{{$t('business_school.what_do_you_think_of_course')}}</h4>
            </van-dialog>
            <sd-button v-if="courseInfo.isTest==1" class="exam" @click.native="toTestSite">{{$t('text.take_an_exam')}}</sd-button>
        </div>
        <template v-if="(courseInfo.path||'').includes('pdf')">
            <pdf v-if="showPDF" @close="closePre" :pdfSrc="$utils.setSourcePath(courseInfo.path)"></pdf>
        </template>
        <template v-else>
            <image-list class="media" v-if="imagesList.length>0" :list.sync="imagesList"></image-list>
        </template>

    </div>
</template>

<script>

import imageList from "@/components/base/images.vue";
import pdf from "@/components/base/pdf.vue";

export default {
    name: "cases",
    components: { pdf, imageList },
    data() {
        return {
            courseId: '',
            courseInfo: {
                title: '【P1】How to install wall tiles :',
                name: 'TIAN XINYANG',
                infoImg: 'https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg',
                url: 'https://fastly.jsdelivr.net/npm/@vant/assets/apple-1.jpeg',
                type: 'Product Course',
                time: '8min',
                introduce: '<p>This course will help you konw the difference between different tile brands and how to selece the best tiles for your project</p>',
                star: 0
            },
            showStar: false,
            showPDF: false,
            imagesList: [],

        }
    },

    computed: {

    },

    watch: {
        imagesList(nowVal, oldVal) {
            if(oldVal.length>0&&(oldVal[0].type||'')=='video'){
                if (window.h5_to_flutter) {
                    console.log('关闭横屏');
                    window.h5_to_flutter.postMessage('closeHorizontal');
                }
            }
        }
    },

    mounted() {
        const body = document.body;
        body.classList.add('school-index-body');
        // 判断会话存储中是否存在 courseId，如果存在则转换为字符串后使用它，否则使用路由参数中的 id
        let storedCourseId = sessionStorage.getItem("courseId");
        if(storedCourseId)storedCourseId = JSON.parse(storedCourseId);
        this.courseId = this.$route.query.id || storedCourseId || '';
        this.getDetail()
    },

    methods: {
        back(){
            if (sessionStorage.getItem("courseId")) {
                sessionStorage.removeItem("courseId");
                this.$router.push('/business-school')
                // if (window.h5_to_flutter) {
                //     window.h5_to_flutter.postMessage('exit')
                // }
            }else{
                this.$router.go(-1)
            }

        },
        closePre(){
            this.showPDF = false
        },
        handlerStar() {
            this.$apis.school.courseStar({courseId: this.courseId, star: this.courseInfo.star}).then(res => {
                this.$apis.school.userEventData({eventName: 'course_star'});
                this.$utils.message(this, this.$t('text.thank_you_for_your_feedback'));
                this.getDetail();
                this.showStar = false;
            }).catch(err => {
                this.$utils.message(this, this.$t('text.failed_to_submit_feedback'));
            })
        },
        showVideo() {
            if ((this.courseInfo.path||'').includes('pdf')) {
                this.showPDF = true
            } else {
                this.imagesList = [
                    {
                    type: (this.courseInfo.path||'').includes('mp4') ? "video" : "pic",
                    path: this.$utils.setSourcePath(this.courseInfo.path),
                    videoPath: this.$utils.setSourcePath(this.courseInfo.path),
                    videoKey: this.$utils.setSourcePath(this.courseInfo.path)
                    }
                ];
                (this.courseInfo.path||'').includes('mp4')&&this.$nextTick(() => {
                    if (window.h5_to_flutter) {
                        console.log('打开横屏');
                        window.h5_to_flutter.postMessage('openHorizontal');
                    }
                    const video = document.querySelector('video');
                    console.log('视频播放开始');
                    video.addEventListener('ended', this.ended, true);
                });
            }
        },
        ended(){
            this.$apis.school.userEventData({eventName: 'course_progress'});
            console.log('视频播放完毕');
        },
        toTestSite(){
            window.location.href = this.courseInfo.testSite
        },
        favorited(){
            this.$apis.school.courseFav({courseId:this.courseInfo.id}).then(res=>{
                if (res.data.data.isFav == 1) this.$utils.message(this, this.$t('text.favorite_successfully'));
                this.courseInfo.isFav = res.data.data.isFav
            })
        },
        getDetail(){
            this.$apis.school.getCourseDetail({courseId:this.courseId}).then(res => {
                this.courseInfo = res.data
                this.$store.commit("changeLoading", false);
            }).catch(err => {
                this.$store.commit("changeLoading", false);
            })
        },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
        const body = document.body;
        body.classList.remove('school-index-body');
    }
}
</script>

<style lang="scss">
.learn-detail {
    font-size: 14px;
    height: 100%;
    overflow: auto;
    background: #F4F5F8;
    &::-webkit-scrollbar {
        display: none;
    }
    .back{
        color: #ccc;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 20px;
        top: 20px;
        z-index: 1;
        i{
            font-size: 20px;
        }
    }
    .internalCourse{
        // height: 60%;
        margin-bottom: 10px;
        padding-bottom: 10px;
        background-color: #fff;
        .video {
            height: 375px;
            position: relative;
            background-color: gray;

            .play {
            width: 67px;
            height: 67px;
            position: absolute;
            top: calc(50% - 33.5px);
            left: calc(50% - 33.5px);
            }
        }
        .van-image--round{
            width: 40px;
            height: 40px;
        }
        .courseImg{
            width: 100%;
            height: 300px;
        }
        .userinfo{
            margin: 10px;
            display: flex;
            align-items: center;
            .van-image--round{
                width: 40px;
                height: 40px;
            }
            .name{
                margin-left: 10px;
            }
        }
        .title{
            text-align: left;
            font-size: 18px;
            padding: 0 10px;
            word-break: break-word;
            // height: 40px;
        }
        .tagAndRate{
            display: flex;
            justify-content: space-between;
            padding: 0 12px;
            .tags{
                color: #636872;
                font-size: 12px;
                line-height: 20px;
                display: flex;
                font-weight: bold;
                div {
                border-radius: 2px;
                background: #e6e7ea;
                margin-right: 6px;
                padding: 0 4px;
                }
                & div:last-child{
                    color: white;
                    background: linear-gradient(270deg, #e22f25 0%, #ed4a3c 100%);
                }
            }
            .star{
                color: #fff;
                display: inline-block;
                width: 20px;
                height: 20px;
                line-height: 20px;
                background: #f7b829;
                border-radius: 50%;
            }
        }
    }
    .courseIntroduce{
        // height: calc(40% - 50px);
        min-height: 160px;
        margin-bottom: 50px;
        background-color: #fff;
        overflow: hidden;
        .title{
            margin: 10px;
            width: calc(100% - 20px);
            text-align: left;
            font-size: 20px;
            height: 26px;
        }
        .introduce{
             overflow-wrap: break-word;
             word-break: normal;
             text-align: left;
             padding: 0 5px;
        }
    }
    .tabbar{
        height: 50px;
        line-height: 50px;
        width: 100%;
        position: fixed;
        bottom: 0;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        background-color: #fff;
        .footer-button {
            width: 44px;
            height: 44px;
            margin-left: 12px;
            .van-icon{
                font-size: 20px;
                padding: 10px;
                border: 1px #eee solid;
                border-radius: 4px;
            }

            img {
                object-fit: contain;
            }

            &:first-child {
                margin-left: 0;
            }
        }
        .like,.edit{
            height: 30px;
            width: 15%;
        }
        .exam{
            height: 30px;
            width: 40%;
        }
        .starDialog{
            width: 320px;
            font-size: 14px;
            .van-dialog__header{
                font-size: 18px;
                font-weight: bold;
            }
            .van-dialog__content{
                h4{
                    color: #787D85;
                }
            }
            .van-button{
                font-size: 14px;
            }
            .van-dialog__cancel, .van-dialog__confirm{
                height: 48px;
            }
            .van-icon-star{
                font-size: 25px !important;
            }
        }
    }
    .media{
        .play {
            width: 67px !important;
            height: 67px !important;
            top: calc(50% - 33.5px) !important;
            left: calc(50% - 33.5px) !important;
        }
        .close{
            top: 24px !important;
            left: 20px !important;
            width: 48px !important;
            height: 48px !important;
        }
    }
}
.school-index-body {

    .project-message {
        width: 302px !important;
        bottom: calc(50% - 10px) !important;
        left: calc(50% - 152px) !important;
        line-height: 20px !important;
        font-size: 14px !important;
        &.middle {
            bottom: 50%;
        }
        .text {
            border-radius: 29.5px !important;
            padding: 12px 25px !important;
            &.login-msg {
                border-radius: 13px !important;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/detail.vue